import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTransferPricingBenchmark } from './types';

export function useTransferPricingBenchmark(benchmarkId: string | null) {
  const baseUrl = `transfer-pricing/benchmark/${benchmarkId}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TTransferPricingBenchmark;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    benchmarkId ? baseUrl : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
